import { useHistory } from "react-router-dom";
import { SESSION_STORAGE_ABLTC_OBJECT_KEY } from "../../../../../sessionStorage";

export default function HowToPurchaseData() {
    let history = useHistory();
    return {
        title: 'How to Purchase',
        paragraphs: [`<div>For Brighthouse, Nationwide, and Pacific Life Products: Please <a id="abltc-link" class="redirect-link">CLICK HERE</a> to request illustrations.<div>`,
        `<br/><div>For Lincoln Product: Please <a href='https://wm3dr.ms.com/pub/content/wm3dr/basepage/insurance/document-pages/Lincoln-MoneyGuard-Wholesaler-Map_102019.html' target="_blank">CLICK HERE</a> to find a representative for your branch.</div>`
        ],
        linkId: 'abltc-link',
        onLinkClick : () => {
            sessionStorage.removeItem(SESSION_STORAGE_ABLTC_OBJECT_KEY);
            history.push('/Products/ABLTC');
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/HowToPurchaseData.js